<template>
  <v-card class="mx-auto" max-width="500" tile flat>
    <v-list-item-group v-model="selected" active-class="gray--text">
      <v-list-item v-for="(item, index) in list" :key="index" two-line>
        <v-list-item-content>
          <v-list-item-title>{{ item.name }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-item-group>

    <v-card-actions class="px-0">
      <v-btn
        outlined
        depressed
        large
        color="grey"
        @click.prevent="$emit('close')"
      >
        {{ $t('BUTTON.CANCEL') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        :disabled="selected === undefined"
        depressed
        color="error"
        large
        @click.prevent="remove"
      >
        {{ $t('BUTTON.DELETE') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'ServiceTypesListPopup',

  data: () => ({
    selected: 0
  }),

  computed: {
    list() {
      return [
        {
          name: this.$t('PLANNINGS.TASKS.EVENT.CURRENT_TASK'),
          value: 0
        },
        {
          name: this.$t('PLANNINGS.TASKS.EVENT.CURRENT_TASK_ALL'),
          value: 1
        }
      ];
    }
  },

  created() {
    this.selected = 0;
  },

  methods: {
    remove() {
      this.$emit('remove', this.list[this.selected].value);
    }
  }
};
</script>
